export default {
  SET_CURRENT_USER (state, currentUserData) {
    state.currentUser = currentUserData
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/userMutations.js